export default "__VITE_ASSET__DN8Vsy$F__"